import { virgulaPonto } from '../../util/util';
import { cambioBrlLinha, temCambioProprio } from './moedaFornecedorPolicy';

// Preço de catálogo (fixo ou por faixa) é cadastrado em reais. Em orçamento em
// moeda estrangeira o unitário da grade é na moeda do orçamento: divide pelo câmbio
// (planilhas Sanofi/AbbVie Inter: RSVP R$ 66 com câmbio 5 = US$ 13,20).
export const divisorPrecoCatalogo = (moeda = 'real', cambio = 1) => {
    const moedaNormalizada = String(moeda || 'real').toLowerCase();
    const cambioNumero = virgulaPonto(cambio);
    return moedaNormalizada !== 'real' && cambioNumero > 0 ? cambioNumero : 1;
};

export const precoCatalogoNaMoeda = (valor, divisor = 1) => {
    const numero = virgulaPonto(valor);
    if (!Number.isFinite(numero) || divisor === 1) return valor;
    return Math.round((numero / divisor) * 1000000) / 1000000;
};

// Moeda do fornecedor (27/09): linha com câmbio próprio divide o preço em R$ pelo câmbio DELA na
// etapa (BRL próprio = 1); legado segue o câmbio global do orçamento (divisorPrecoCatalogo).
export const divisorPrecoCatalogoLinha = (linha = {}, momento = 'PreEvento', moeda = 'real', cambio = 1) => {
    if (!temCambioProprio(linha)) return divisorPrecoCatalogo(moeda, cambio);
    const c = cambioBrlLinha(linha, momento, 1);
    return c > 0 ? c : 1;
};
